import React from 'react';
import {Props} from './model';
import {View, ImageBackground} from 'react-native';
import {useTheme} from '../../../../../shared/theme';
import {useStyles} from '../../../../../shared/hooks/styles';
import {LkBack} from '../../../../../assets/images';
import {datePipe} from '../../../../../shared/pipes/date';
import {Text} from '../../../../../shared/components/text';
import {CardNumber} from '../../../../../shared/components/cardNumber';
import {GradientView} from '../../../../../shared/components/gradientView';
import {images} from '../../../../../assets/icons';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';

export default ({dateUntil, isCampusParticipant}: Props) => {
  const theme = useTheme();
  const visuallyImpairedSettings = useSelector(themeSelector());
  const visActive = !!visuallyImpairedSettings?.visuallyImpaired;
  const styles = useStyles(() => {
    return {
      container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        backgroundColor:
          isCampusParticipant && !visActive
            ? theme.campus.backgroundColor
            : visActive
            ? 'white'
            : theme.color.cardBackground,
        height: 69,
        paddingHorizontal: 30,
        overflow: 'hidden',
      },
      dateContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        paddingHorizontal: 20,
        marginTop: 8,
      },
      dateLabel: {
        ...theme.fonts.label,
        color: visActive ? 'black' : theme.color.labelText,
      },
      dateValue: {
        ...theme.fonts.bodySmallLight,
        color: visActive ? 'black' : theme.color.labelText,
        marginLeft: 8,
        paddingRight: 2,
        marginRight: -2,
      },
      numberContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
      cardNumber: {
        minWidth: 230,
      },
      cardNumberText: {
        ...theme.fonts.h5,
        color: visActive ? 'black' : theme.color.cardText,
      },
      eyeIcon: {marginLeft: 20},
      campusIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 90,
        height: 90,
        transform: [{translateX: 32}, {translateY: -24}],
        zIndex: -1,
      },
    };
  });

  const cardNumberComponent = (
    <CardNumber
      useLabel
      hiddenIconColor={theme.color.cardText}
      visibleIconColor={theme.color.cardText}
      style={styles.cardNumber}
      textStyle={styles.cardNumberText}
      iconProps={{style: styles.eyeIcon}}
    />
  );

  return (
    <View testID='use-info-id'>
      {isCampusParticipant ? (
        <GradientView style={styles.container} gradient={{angle: 135, colors: theme.campus.gradient}}>
          {cardNumberComponent}
          <View style={styles.campusIcon}>
            <images.Heart color={visActive ? 'black' : theme.campus.backgroundColor} />
          </View>
        </GradientView>
      ) : (
        <ImageBackground source={LkBack as any} style={styles.container}>
          {cardNumberComponent}
        </ImageBackground>
      )}
      <View testID='date-container-id' style={styles.dateContainer}>
        <View testID='date-nested-container-id' style={styles.numberContainer}>
          <Text testID='date-label-id' style={styles.dateLabel} numberOfLines={1}>
            Дата выдачи
          </Text>
          <Text testID='date-text-id' style={styles.dateValue} numberOfLines={1}>
            {datePipe(dateUntil)}
          </Text>
        </View>
      </View>
    </View>
  );
};
